/**
 * The small cross that takes a chip off the case: a source, a tool call.
 */

import { X } from 'lucide-react';

export const RemoveButton = ({ label, onClick }: { label: string; onClick: () => void }) => (
	<button
		type='button'
		onClick={onClick}
		aria-label={label}
		className='rounded-md p-1 text-gray-800 transition-colors hover:bg-gray-100 hover:text-text-heading'
	>
		<X className='size-3' />
	</button>
);
